module.exports = __webpack_public_path__ + "resources/img/img_cubrid_01_m.b9293b106a8d291760e9e1dab23766ca.png";